import MiniProgramPage from 'D:/zxl/workspace/saveWorkSpace/nongtou-uni/subpackage/manager/progress.vue'
wx.createPage(MiniProgramPage)